import { Box, Card, CardContent } from '@mui/material';
import axios from 'axios';
import React, { Fragment, useEffect, useState } from 'react';
import { Subtitle, BodyText } from '../components/Text';

const DependenciesList = () => {
  const [dependencies, setDependencies] = useState([]);

  useEffect(() => {
    axios.get('dependencies.json').then((response) => {
      setDependencies(response.data);
    });
  }, []);

  return (
    <div>
      <Box
        sx={{
          mx: 3,
          mt: 1,
        }}
      >
        <Subtitle noWrap={false}>
          Shared Views Panel {APP_VERSION.replace('v', '')} © 2023 Autodesk, Inc. All rights reserved.
        </Subtitle>
        <br />
        <Subtitle noWrap={false}>
          All use of this Software is subject to the Autodesk terms of service accepted upon access or use of this
          Service or made available on the Autodesk webpage. Autodesk terms of service for Autodesk’s various
          webservices can be found <a href="https://www.autodesk.com/company/terms-of-use/en/general-terms">here.</a>
        </Subtitle>
        <br />
        <Subtitle>Privacy</Subtitle>
        <BodyText noWrap={false}>
          To learn more about Autodesk’s online and offline privacy practices, please see the{' '}
          <a href="https://www.autodesk.com/company/legal-notices-trademarks/privacy-statement">
            Autodesk Privacy Statement
          </a>
          .
        </BodyText>
        <br />
        <Subtitle>Autodesk Trademarks</Subtitle>
        <BodyText noWrap={false}>
          The trademarks on the{' '}
          <a href="https://www.autodesk.com/company/legal-notices-trademarks/trademarks/autodesk-inc">
            Autodesk Trademarks page
          </a>{' '}
          are registered trademarks or trademarks of Autodesk, Inc., and/or its subsidiaries and/or affiliates in the
          USA and/or other countries. All other brand names, product names or trademarks belong to their respective
          holders.
        </BodyText>
        <br />
        <Subtitle>Patents</Subtitle>
        <BodyText noWrap={false}>
          This Service is protected by patents listed on the{' '}
          <a href="https://www.autodesk.com/company/legal-notices-trademarks/patents">Autodesk Patents page</a>.
        </BodyText>
        <br />
        <Subtitle>Autodesk Cloud and Desktop Components</Subtitle>
        <BodyText noWrap={false}>
          This Service may incorporate or use background Autodesk online and desktop technology components. For
          information about these components, see{' '}
          <a href="https://www.autodesk.com/company/legal-notices-trademarks/autodesk-cloud-platform-components">
            Autodesk Cloud Platform Components
          </a>{' '}
          and{' '}
          <a href="https://www.autodesk.com/company/legal-notices-trademarks/autodesk-desktop-platform-components">
            Autodesk Desktop Platform Components
          </a>
          .
        </BodyText>
        <br />
        <Subtitle>Third-Party Trademarks, Software Credits and Attributions</Subtitle>
      </Box>
      {dependencies.map((dependency) => (
        <Card
          key={dependency.name}
          sx={{
            m: 1,
          }}
        >
          <CardContent>
            <Subtitle>{dependency.name}</Subtitle>
            <BodyText noWrap={false}>
              {dependency.licenseText
                ? dependency.licenseText.split('<br>').map((line, index) => (
                    <Fragment key={index}>
                      {line}
                      <br />
                    </Fragment>
                  ))
                : dependency.licenseName}
            </BodyText>
          </CardContent>
        </Card>
      ))}
    </div>
  );
};

export default DependenciesList;
